import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { NavLink } from "react-router-dom";
import Badge from "react-bootstrap/Badge";
const dayjs = require("dayjs");

function Ticket({
  id,
  title,
  date,
  accountName,
  status,
  supportClosed,
  role,
}) {
  
  const statusSelector = (status) => {
    if (role === "root") {
      if (status === "open") {
        return (
          <Badge pill bg="primary" className="status-badge">
            Abierto
          </Badge>
        );
      } else if (status === "pending") {
        return (
          <Badge pill bg="info" className="status-badge">
            Pendiente
          </Badge>
        );
      } else if (status === "closed") {
        return (
          <Badge pill bg="secondary" className="status-badge">
            Cerrado
          </Badge>
        );
      }
    } else if (role === "admin") {
      if (status === "open" || status === "pending") {
        return (
          <Badge pill bg="primary" className="status-badge">
            Abierto
          </Badge>
        );
      } else if (status === "closed") {
        return (
          <Badge pill bg="secondary" className="status-badge">
            Cerrado
          </Badge>
        );
      }
    } else if (role === "support") {
      if (status === "open" || status === "pending") {
        return (
          <Badge pill bg="primary" className="status-badge">
            Abierto
          </Badge>
        );
      } else if (status === "closed") {
        return (
          <Badge pill bg="secondary" className="status-badge">
            Cerrado
          </Badge>
        );
      }
    }
  };

  return (
    <Col className="ticket-container">
      <Row className="justify-content-center align-items-center">
        <Col lg={2}>
          <strong>{dayjs(date).format("DD-MMM-YYYY")}</strong>
        </Col>
        <Col lg={2}>
          <h6>{accountName}</h6>
        </Col>
        <Col lg={6}>
          <NavLink to={`/ticket-details/${id}`}>
            <h6>{title}</h6>
          </NavLink>
        </Col>
        <Col lg={1}>{statusSelector(status)}</Col>
        <Col lg={1}>
          {supportClosed ? (
            <Badge pill bg="dark" className="status-badge">
              Reparado
            </Badge>
          ) : (
            <></>
          )}
        </Col>
      </Row>
    </Col>
  );
}

export default Ticket;
